import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages } from "src/app/common/Const";
import { ME200018 } from "src/app/common/const-message-id";
import { GC_D2016_CORR_SLIP } from "src/app/common/ConstCcd";
import { TableColumnDef } from "src/app/common/table-column-def";
import { ReqAccess } from "src/app/request/req-access";
import { Spmt10271DetailCommentDto } from "src/app/request/req-spmt10271-confirm";
import { ReqSpmt10271DetailSearch } from "src/app/request/req-spmt10271-search";
import { Spmt10271DetailSearchRowDto } from "src/app/response/rsp-spmt10271-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";

export enum ColumnIds {
  SlipLineNo = "slipLineNo",
  ProductCd = "productCd",
  StandardNm = "standardNm",
  ProductNm = "productNm",
  OutStockQty = "outStockQty",
  OutCostExc = "outCostExc",
  OutCostAmtExc = "outCostAmtExc",
  OutSellPriceExc = "outSellPriceExc",
  OutSellPriceAmtExc = "outSellPriceAmtExc",
  OutSlipDtlComment = "outSlipDtlComment",
  OutSlipDtlApproverComment = "outSlipDtlApproverComment",
  InSlipDtlApproverComment = "inSlipDtlApproverComment",
  ErrorMessage = "errorMessage",
}

export enum ColumnHeaders {
  SlipLineNo = "伝票行番号",
  ProductCd = "商品コード",
  StandardNm = "規格",
  OutStockQty = "出庫数量",
  OutCostExc = "出庫原単価(抜)",
  OutSellPriceExc = "出庫売単価(抜)",
  OutSlipDtlComment = "出庫店伝票詳細コメント",
  OutSlipDtlApproverComment = "出庫店伝票詳細承認者コメント",
  InSlipDtlApproverComment = "入庫店伝票詳細承認者コメント",
  ErrorMessage = "システムメッセージ",
  ProductNm = "商品名称",
  OutCostAmtExc = "出庫原価金額(抜)",
  OutSellPriceAmtExc = "出庫売価金額(抜)",
}

interface TableRow extends Spmt10271DetailSearchRowDto {
  errorMessage: string;
  form: {
    outSlipDtlApproverCommentFormCtrl: FormControl;
  };
}
@Component({
  selector: "spmt10271-detail-dialog",
  templateUrl: "./spmt10271-detail-dialog.component.html",
  styleUrls: ["./spmt10271-detail-dialog.component.css"],
})
export class Spmt10271DetailDialogComponent implements OnInit, AfterViewInit {
  columnIdFirst: string[] = [
    ColumnIds.SlipLineNo,
    ColumnIds.ProductCd,
    ColumnIds.StandardNm,
    ColumnIds.OutStockQty,
    ColumnIds.OutCostExc,
    ColumnIds.OutSellPriceExc,
    ColumnIds.OutSlipDtlComment,
    ColumnIds.OutSlipDtlApproverComment,
    ColumnIds.InSlipDtlApproverComment,
    ColumnIds.ErrorMessage,
  ];
  columnIdSecond: string[] = [ColumnIds.ProductNm, ColumnIds.OutCostAmtExc, ColumnIds.OutSellPriceAmtExc];
  columnDefsItemsFirst: TableColumnDef[] = [
    { columnId: ColumnIds.SlipLineNo, header: ColumnHeaders.SlipLineNo, width: 70, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.ProductCd, header: ColumnHeaders.ProductCd, width: 105, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.StandardNm, header: ColumnHeaders.StandardNm, width: 85, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.OutStockQty, header: ColumnHeaders.OutStockQty, width: 70, align: Alginment.Right, rowspan: 2, numberPipe: "1.0-0" },
    { columnId: ColumnIds.OutCostExc, header: ColumnHeaders.OutCostExc, width: 100, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.OutSellPriceExc, header: ColumnHeaders.OutSellPriceExc, width: 100, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.OutSlipDtlComment, header: ColumnHeaders.OutSlipDtlComment, width: 150, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.OutSlipDtlApproverComment, header: ColumnHeaders.OutSlipDtlApproverComment, width: 150, align: Alginment.Left, rowspan: 2, isTextbox: true },
    { columnId: ColumnIds.InSlipDtlApproverComment, header: ColumnHeaders.InSlipDtlApproverComment, width: 150, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.ErrorMessage, header: ColumnHeaders.ErrorMessage, width: 150, align: Alginment.Left, rowspan: 2, class: "error-message" },
  ];

  columnDefsItemsSecond: TableColumnDef[] = [
    { columnId: ColumnIds.ProductNm, header: ColumnHeaders.ProductNm, width: 190, align: Alginment.Left, rowspan: 1, colspan: 2 },
    { columnId: ColumnIds.OutCostAmtExc, header: ColumnHeaders.OutCostAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
    { columnId: ColumnIds.OutSellPriceAmtExc, header: ColumnHeaders.OutSellPriceAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
  ];

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  itemTableWidth: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private readonly dialogRef: MatDialogRef<Spmt10271DetailDialogComponent>,
    private readonly httpBasic: HttpBasicService,
    private readonly messages: MessageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      access: ReqAccess;
      isDisableRow: boolean;
      outStoreCd: string;
      outStoreNm: string;
      inStoreCd: string;
      inStoreNm: string;
      systemSlipNo: string;
      slipNo: string;
      updDateTime: string;
      details: Spmt10271DetailCommentDto[];
      redBlackFlg: string;
    },
    public commonService: CommonService
  ) {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  get GC_D2016_CORR_SLIP() {
    return GC_D2016_CORR_SLIP;
  }

  private fnSearch() {
    const req: ReqSpmt10271DetailSearch = {
      access: this.data.access,
      systemSlipNo: this.data.systemSlipNo,
      updDateTime: this.data.updDateTime,
      disableRow: this.data.isDisableRow,
      storeCd: this.data.outStoreCd,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10271DetailSearch(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.dataSource.data = res.rows.map((item) => ({
          ...item,
          errorMessage: item.outOfStockFlg ? this.messages.message[ME200018].replace("%1", "出庫数量") : EMPTY_STRING,
          form: {
            outSlipDtlApproverCommentFormCtrl: new FormControl({
              value: this.data.details.find((detail) => detail.systemSlipDetailNo === item.systemSlipDetailNo)?.outSlipDtlApproverComment || item.outSlipDtlApproverComment,
              disabled: this.data.isDisableRow,
            }),
          },
        }));
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  ngOnInit() {
    this.calcTableWidth();
    this.fnSearch();
  }

  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }

  btnConfirmClick(): void {
    const result = this.dataSource.data.map((item) => {
      return {
        systemSlipDetailNo: item.systemSlipDetailNo,
        outSlipDtlApproverComment: item.form.outSlipDtlApproverCommentFormCtrl.value,
      };
    });

    this.dialogRef.close(result);
  }
}
